/* src/app/admin/audit-log/audit-log.component.scss */
/*# sourceMappingURL=audit-log.component-3ARNZGO2.css.map */
